var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3. Project Plan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8,46.5H10.2a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1h7.4a1,1,0,0,1,0,2H11.2V44.5H36.8V10H30.4a1,1,0,1,1,0-2h7.4a1,1,0,0,1,1,1V45.5A1,1,0,0,1,37.8,46.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,19.59a1.6,1.6,0,1,1-1.6,1.6A1.6,1.6,0,0,1,16,19.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.58,22.19H19.88a1,1,0,0,1,0-2h13.7a1,1,0,0,1,0,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,26.6a1.6,1.6,0,1,1-1.6,1.6A1.6,1.6,0,0,1,16,26.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.58,29.2H19.88a1,1,0,0,1,0-2h13.7a1,1,0,0,1,0,2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,33.6a1.6,1.6,0,1,1-1.6,1.6A1.6,1.6,0,0,1,16,33.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.58,36.2H19.88a1,1,0,1,1,0-2h13.7a1,1,0,0,1,0,2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4,13.37H17.6a1,1,0,0,1-1-1V5.87a1,1,0,0,1,1-1h3.06V4.2a2.7,2.7,0,0,1,2.7-2.7h1.28a2.69,2.69,0,0,1,2.69,2.7v.67H30.4a1,1,0,0,1,1,1v6.5A1,1,0,0,1,30.4,13.37Zm-11.8-2H29.4V6.87H26.33a1,1,0,0,1-1-1V4.2a.7.7,0,0,0-.69-.7H23.36a.71.71,0,0,0-.7.7V5.87a1,1,0,0,1-1,1H18.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.145d3d97d166e3a8e09634e3e74f22cb.svg";
export { ForwardRef as ReactComponent };